export default __webpack_public_path__ + "static/media/time-clock-circle.a4df5b22.svg";